<script setup>
import Cookies from 'js-cookie';
import { ref, onMounted } from 'vue'
import { Link } from '@inertiajs/vue3';
const showBanner = ref(true);

// Check cookie consent status on load
onMounted(() => {
    const consent = Cookies.get('cookie_consent');
    if (consent === '1' || consent === '0') {
        showBanner.value = false;
    }
});

// Set cookie and hide the banner when user accepts
const onAccept = () => {
    Cookies.set('cookie_consent', '1', { expires: 365, path: '/', secure: true, sameSite: 'Strict' });
    showBanner.value = false; // Hide the banner
};

// Set cookie and hide the banner when user rejects
const onReject = () => {
    Cookies.set('cookie_consent', '0', { expires: 1, path: '/', secure: true, sameSite: 'Strict' });
    showBanner.value = false; // Hide the banner
};


</script>

<template>
    <div v-if="showBanner" class="bg-primary text-white fixed bottom-0 left-0 w-full z-50">
        <div class="container mx-auto px-4 py-6 sm:px-6">
            <h1 class="py-4 text-lg sm:text-xl flex items-center">
                <i class="fa-solid fa-cookie-bite mr-2"></i> Privacy and cookies
            </h1>
            <div class="flex flex-col sm:flex-row sm:items-center justify-between">
                <div class="sm:w-3/5">
                    <p class="text-sm sm:text-base leading-relaxed">
                        We and our third-party partners use cookies and similar technologies to run the website. Some
                        cookies are
                        strictly necessary. We also use optional cookies to provide a more personalized experience,
                        improve the way
                        our websites work and support our marketing operations. Optional cookies will only be set with
                        your consent.
                    </p>
                </div>
                <div class="sm:w-2/5 flex flex-col sm:flex-row justify-center sm:justify-end sm:space-x-4 mt-4 sm:mt-0">
                    <button @click="onReject"
                        class="bg-transparent px-6 py-2 mb-2 sm:mb-0 border-2 border-white rounded-full text-sm sm:text-lg hover:bg-white hover:text-black transition duration-300">
                        Reject All
                    </button>
                    <button @click.prevent="onAccept"
                        class="bg-transparent px-6 py-2 border-2 border-white rounded-full text-sm sm:text-lg hover:bg-white hover:text-black transition duration-300">
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style></style>
